(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hormone-tracking-510"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.Swiper) {
    new Swiper('.nht-carousel.swiper', {
      slidesPerView: 1.15, // mobile = 1 full + peek (unchanged)
      spaceBetween: 16,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.nht-next',
        prevEl: '.nht-prev',
      },
      watchOverflow: true,
      keyboard: { enabled: true },
      breakpoints: {
        768: {   // tablet
          slidesPerView: 3.5,
          spaceBetween: 16
        },
        1200: {  // desktop
          slidesPerView: 3.5,
          spaceBetween: 10
        }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inne-tabs-510"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.expect-30days-section').forEach(function(section) {
    var tabSwiper = null;

    // Init Swiper for this section's tabs (mobile scrollable, desktop fine)
if (window.Swiper) {
  var swiperEl = section.querySelector('.expect-30days-tabs.swiper');
  if (swiperEl) {
    tabSwiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',   
      spaceBetween: 8,
      freeMode: true,
      slideToClickedSlide: true,
      watchOverflow: true
    });
  }
}

    function updateVisualFromIdx(idx) {
      var content = section.querySelector('.expect-30days-tab-content[data-tab-content-index="' + idx + '"]');
      var imgEl   = content ? content.querySelector('.expect-30days-image img') : null;
      var visual  = section.querySelector('.expect-30days-visual');
      var vImg    = visual ? visual.querySelector('img') : null;

      if (!visual || !vImg) return;

      if (imgEl && imgEl.getAttribute('src')) {
        visual.classList.add('is-swapping');
        vImg.onload = function() { visual.classList.remove('is-swapping'); };
        vImg.src = imgEl.getAttribute('src');
        vImg.alt = imgEl.getAttribute('alt') || '';
        visual.style.display = '';
      } else {
        vImg.removeAttribute('src');
        vImg.alt = '';
        visual.style.display = 'none';
      }
    }

    function setActiveTab(idx) {
      // Tabs
      section.querySelectorAll('.expect-30days-tab').forEach(function(t) { t.classList.remove('active'); });
      var realTabs = section.querySelectorAll('.expect-30days-tab[data-tab-index]');
      if (realTabs[idx]) realTabs[idx].classList.add('active');

      // Contents
      section.querySelectorAll('.expect-30days-tab-content').forEach(function(c) { c.classList.remove('active'); });
      var content = section.querySelector('.expect-30days-tab-content[data-tab-content-index="' + idx + '"]');
      if (content) content.classList.add('active');

      // Visual
      updateVisualFromIdx(idx);
    }

    // Click handlers
    section.querySelectorAll('.expect-30days-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        var idx = parseInt(this.getAttribute('data-tab-index'), 10) || 0;
        setActiveTab(idx);
        if (tabSwiper) tabSwiper.slideTo(idx);
      });
    });

    // Sync when swiping the tabs (optional)
    if (tabSwiper) {
      tabSwiper.on('slideChange', function() {
        setActiveTab(tabSwiper.activeIndex);
      });
    }

    // Initial state (first active)
    var initial = section.querySelector('.expect-30days-tab.active');
    var startIdx = initial ? parseInt(initial.getAttribute('data-tab-index'), 10) : 0;
    setActiveTab(startIdx);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-gynecologists"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.Swiper) {
    new Swiper('.gynecologist-carousel.swiper', {
      slidesPerView: 1.15, // Mobile: 1 full + peek
      spaceBetween: 16,
      breakpoints: {
        640: {
          slidesPerView: 1.15, // Still mobile
          spaceBetween: 16
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 24
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24
        }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
